<template>
  <div class="menubuilder__certification">
    <h3>Certification</h3>
    <p>Would you like the coffee accreditation logos and descriptions to show on you menu?</p>

    <div class="menubuilder__radiowrapper">

      <label for="certificate_yes">
        Yes
        <br>
        <input type="radio" v-model="hasCertifications.value" value="true" id="certificate_yes" name="certificate_yes" />
      </label>
      <label for="certificate_no">
        No
        <br>
        <input type="radio" v-model="hasCertifications.value" value="false"  id="certificate_no" name="certificate_no" />
      </label>
    </div>


    <div class="menubuilder__images">
      <div class="img">
        <img v-bind:src="organicLogo.url" />
      </div>
      <div class="img">
        <img v-bind:src="fairtradeLogo.url" />
      </div>
      <div class="img">
        <img v-bind:src="rainforestLogo.url" />
      </div>
    </div>
  </div>
</template>


<script>
  export default {

    data: function () {
      return {
        organicLogo: menuBuilderSettings.organicLogo,
        fairtradeLogo: menuBuilderSettings.fairtradeLogo,
        rainforestLogo: menuBuilderSettings.rainforestLogo,
        hasCertifications: this.$store.state.hasCertifications,
        texts: this.$store.state.texts,
      };
    },
    computed: {
    },
    props: [],
    methods: {
    },
    computed: {
    },
    async mounted() {
    }
  }

</script>


<style lang="sass">
@import "../../../../styles/partials/variables"

#menubuilder

  .menubuilder
    &__certification
      margin-top: 50px
    &__radiowrapper
      display: flex
      flex-flow: row
    &__images
      margin: 30px 0
      display: flex
      flex-flow: row wrap
      justify-content: space-around
      align-items: center

      .img
        flex: 0 1 80px
        text-align: center
        //margin-right: 50px
        &:last-child
          flex: 0 1 160px

      img
        height: auto
        max-width: 100%

  label
    font-size: 15px
    font-weight: 600
    margin-right: 15px

    input[type=radio]
      margin-top: 15px

    input[type='radio']:after
      width: 20px
      height: 20px
      border-radius: 20px
      top: -2px
      left: -1px
      position: relative
      background: $color-white
      border: 2px solid $color-black!important
      cursor: pointer;
      padding: 2px
      content: ''
      display: inline-block
      visibility: visible
      border: 2px solid white


    input[type='radio']:checked:after
      width: 20px
      height: 20px
      border-radius: 20px
      top: -2px
      left: -1px
      position: relative
      padding: 2px !important
      background: radial-gradient($color-black 0px, $color-black 4px, $color-white 4px, $color-white)
      content: ''
      display: inline-block
      visibility: visible
      border: 2px solid white



</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/CertificationSelector.vue